import { useState, useEffect } from "react";
import { useRaspStore } from "../store/raspStore.ts";
import { withdrawalsService } from "../services/WithdrawalService.ts";

export const useWithdrawalsViewModel = (
  userId: string,
  //   appId: string
) => {
  const [fields, setFields] = useState<any[]>([]);
  const [foreignKeyData, setForeignKeyData] = useState<any>({});
  const [enums, setEnums] = useState<any>({});
  const [dataToSave, setDataToSave] = useState<any>({});
  const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(
    new Set()
  );
  const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(
    new Set()
  );

  const addSubmission = useRaspStore((s) => s.addSubmission);
  const getSubmissions = useRaspStore((s) => s.getSubmissions);
  const getUserAllData = useRaspStore((s) => s.getUserAllData);

  useEffect(() => {
    const dataFromStore = getSubmissions(userId, "Withdrawals");
    const allData = getUserAllData(userId);

    console.log(
      "All data from store for withdrawals",
      dataFromStore,
      allData
    );
  }, []);

  const loadMetadata = async () => {
    const metadata = await withdrawalsService.getMetadata();
    const metaFields = metadata[0].fieldValues || [];

    setFields(metaFields);

    // Load Foreign Keys
    for (const field of metaFields) {
      if (field.foreign) {
        const foreignName = field.foreign;

        if (!fetchedForeign.has(foreignName)) {
          const updated = new Set(fetchedForeign);
          updated.add(foreignName);
          setFetchedForeign(updated);

          const data =
            await withdrawalsService.getForeignResource(foreignName);

          setForeignKeyData((prev: any) => ({
            ...prev,
            [foreignName]: data,
          }));
        }
      }
    }

    // Load Enums
    for (const field of metaFields) {
      if (field.isEnum) {
        const enumName = field.possible_value;

        if (!fetchedEnum.has(enumName)) {
          const updatedEnum = new Set(fetchedEnum);
          updatedEnum.add(enumName);
          setFetchedEnum(updatedEnum);

          const values = await withdrawalsService.getEnum(enumName);

          setEnums((prev: any) => ({
            ...prev,
            [enumName]: values,
          }));
        }
      }
    }
  };

  const save = async () => {
    const params = new FormData();

    const jsonString = JSON.stringify(dataToSave);
    const base64Encoded = btoa(unescape(encodeURIComponent(jsonString)));

    params.append("resource", base64Encoded);

    const response = await withdrawalsService.create({
      params,
    });

    if (response.errCode === -1) {
      throw new Error("Failed to save withdrawal.");

    } else if (response.errCode !== -1) {
      addSubmission(userId, "Withdrawals", dataToSave);

      console.log(
        "Withdrawals saved in store",
        getUserAllData(userId)
      );
    }
  };

  return {
    fields,
    setFields,
    enums,
    foreignKeyData,
    setForeignKeyData,
    setEnums,
    dataToSave,
    setDataToSave,
    loadMetadata,
    save,
  };
};